export const IMAGE_UPLOAD_MAX_MB = 2

export const IMAGE_MIME_TYPES = {
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  gif: 'image/gif',
  webp: 'image/webp',
  svg: 'image/svg+xml'
}

// 这里只提供选择文件时的体验校验，真实内容与安全策略必须由服务端独立执行。
export function getImageUploadError (file, mimeTypes, formatLabel, maxSizeMb = IMAGE_UPLOAD_MAX_MB) {
  const extension = String((file && file.name) || '').split('.').pop().toLowerCase()
  const expectedMime = IMAGE_MIME_TYPES[extension]
  const actualMime = String((file && file.type) || '').toLowerCase()
  if (!expectedMime || !mimeTypes.includes(expectedMime) || (actualMime && actualMime !== expectedMime)) {
    return `上传图片仅支持 ${formatLabel} 格式`
  }
  const bytes = Number(file && file.size)
  if (!Number.isFinite(bytes) || bytes <= 0) return '图片文件为空或大小无效'
  if (!Number.isFinite(maxSizeMb) || maxSizeMb <= 0) return '图片大小限制配置无效'
  if (bytes > maxSizeMb * 1024 * 1024) return `上传图片单张不能超过 ${maxSizeMb}MB`
  return ''
}
